import { useQuery } from '@tanstack/react-query'
import getEmployees from './api/getEmployees'
import { useUser } from 'features/authorized/context/user'
import { Employee } from '../../../qr/common/core/entities/employee'

const useEmployees = () => {
    const { user: { currency, organization: { organizationId } } } = useUser()
    return useQuery(
        ['employees', 'get'],
        () => getEmployees({ organizationId, currency }),
        {
            select: (employees) => {
                const ids: number[] = []
                const map: Record<number, Employee> = {}
                employees.forEach((e) => {
                    ids.push(e.id)
                    map[e.id] = e
                })
                return { ids, map }
            },
        },
    )
}

export default useEmployees
